import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-351a0da2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = ["disabled", "value"]
const _hoisted_3 = ["value", "disabled"]
const _hoisted_4 = {
  key: 0,
  value: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "35",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "svg-inline": '',
  class: /*#__PURE__*/_normalizeClass('webins-arrow-icon'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    "fill-opacity": ".01",
    d: "M0 0h48v48H0z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M37 18L25 30 13 18",
    stroke: "#6c757d",
    "stroke-width": "5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_7 = ["value", "onInput", "onKeypress"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M16 4H8v.5a.5.5 0 01-1 0V4H5.5A1.5 1.5 0 004 5.5V8h16V5.5A1.5 1.5 0 0018.5 4H17v.5a.5.5 0 11-1 0V4zm1-1h1.5A2.5 2.5 0 0121 5.5v13.007a2.5 2.5 0 01-2.5 2.5h-13a2.5 2.5 0 01-2.5-2.5V5.5A2.5 2.5 0 015.5 3H7v-.5a.5.5 0 011 0V3h8v-.5a.5.5 0 111 0V3zm3 6H4v9.507a1.5 1.5 0 001.5 1.5h13a1.5 1.5 0 001.5-1.5V9z" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["type", "disabled", "value"]

import { TextValueItem } from "@/models/TextValueItem";
import { ref, watch, computed, onMounted } from "vue";

import VueDatePicker from '@vuepic/vue-datepicker';
import type { DatePickerInstance } from "@vuepic/vue-datepicker"
import '@vuepic/vue-datepicker/dist/main.css';

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import IconInfo from "@/components/icon-info-positional.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    placeHolder: null,
    testoPopup: null,
    hint: null,
    optionLabel: null,
    dataSource: null,
    valueField: null,
    email: { type: Boolean },
    disabled: { type: Boolean },
    type: null,
    value: null,
    min: null,
    max: null,
    minDate: null,
    maxDate: null,
    errore: { type: Boolean }
  },
  emits: ['update:value', 'onSelectDropDown', 'updateValue'],
  setup(__props: any, { emit }) {

const props = __props as {
        placeHolder?: string;
        testoPopup?: string;
        hint?: string;
        optionLabel?: string;
        dataSource?: TextValueItem[];
        valueField?: string
        email?: boolean;
        disabled?: boolean;
        type?: string;
        value?: string | number | Date;
        //date?: Date;
        min?: number | string | Date;
        max?: number | string | Date;
        minDate?: string | Date;
        maxDate?: string | Date;
        errore?: boolean;
    }


dayjs.extend(customParseFormat)

//const value = ref(null);
const field = ref(null);
const date = ref<string>(null);
const dateIsSelected = ref<boolean>(false);

const datepicker = ref<DatePickerInstance>(null);
const inputDate = ref(null);

const hasFocus = ref<boolean>(false);
const resetErrore = ref<boolean>(false);
const focusClass = ref<string>("");







onMounted(() =>{
    if(props.type === "date" && props.value){
        var d = dayjs(props.value);
        d && d.isValid() && ( date.value = d.format("DD/MM/YYYY") );
    }

})

watch(
    () => [date.value],
    () => {
        dateIsSelected.value = date.value ? true : false;
        //dateIsSelected.value = props.date ? true : false;
    },
    { deep: true }
);

watch(
    () => [props.errore],
    () => {
        //if(props.errore ){
            resetErrore.value = false;
        //}
    },
    { deep: true, immediate: true }
);



watch(
    () => [props.value],
    () => {
        if(props.type === "date"){
            date.value = props.value ? dayjs(props.value).format("DD/MM/YYYY") : null;
        }
        
        focusClass.value = hasFocus.value || props.value ? 'focus' : '';
    },
    { deep: true }
);

watch(
    () => [hasFocus.value],
    () => {
        focusClass.value = hasFocus.value || props.value ? 'focus' : '';
    },
    { deep: true }
);

const onDatePickerKeyPress = (event, onKeyPress, onEnter) => {
    onKeyPress(event);
    if(event.keyCode === 13)
        onEnter(event);
};

const onFocus = () => {
    hasFocus.value = true;
}

const onBlur = () => {
    hasFocus.value = false;
}

const handleInput = (e) => {
    emit("update:value", e.target.value );
    if(props.errore){
        resetErrore.value = true;
    }
}

const handleSelectChange = (e) => {
    
    var itemSelected = props.dataSource.find(x => String(x[props.valueField || 'value']) === e.target.value);
    emit("onSelectDropDown", itemSelected );
    emit("update:value", e.target.value );
    if(props.errore){
        resetErrore.value = true;
    }
}

const dateClicked = (date) => {
    setTimeout(() => {
        datepicker.value.selectDate();
    }, 100);
  }

const openDatePicker = (date) => {
    datepicker.value.openMenu();
}
const clearDate = (e) => {
    e.preventDefault();
    e.stopPropagation();
    datepicker.value.clearValue();
    return false;
}


const onCloseDate = () => {    
    if(lockBlurDate){
        lockBlurDate = false;
        return
    }
    var dateText = inputDate.value.value;
    var d = dayjs(dateText, "DD/MM/YYYY");
    if( d && d.isValid() ){
        var minD = props.minDate ? dayjs(props.minDate) : null,
            maxD = props.maxDate ? dayjs(props.maxDate) : null;

        if( (!minD || (minD <= d ) && ( !maxD || (d <= maxD) ) )  ){
            var newD = d.format("DD/MM/YYYY");
            dateModel.value = newD;
            //date.value = newD;
            //lockBlurDate = true;
            //datepicker.value.selectDate();
        }
    }
}



const textInputOptions = {
  openMenu: true,
  format: 'dd/MM/yyyy'
};

const formatDate = (date) => {
  var d = dayjs(date);
  if( d && d.isValid() )
    return d.format("DD/MM/YYYY");
  return date;
};

var lockBlurDate = false;

const dateModel= computed({
    get(): string {
        return date.value || null;
    },
    set(newValue: string): void {
        date.value = newValue;
        var d = dayjs(newValue, "DD/MM/YYYY");
        
        emit("update:value",  d && d.isValid() ? d.toDate() : null );
        emit("updateValue",  d && d.isValid() ? d.toDate() : null );
        if(props.errore){
            resetErrore.value = true;
        }
        if(d.isValid()){
            lockBlurDate = true;
            setTimeout(() => {
                lockBlurDate = false;
            }, 200);

        }
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.type === 'number')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("input", {
            ref_key: "field",
            ref: field,
            onInput: handleInput,
            class: _normalizeClass(["webins-custom-input", { 'focus': hasFocus.value || __props.value, 'webins-error-field': __props.errore }]),
            type: "number",
            min: "0",
            onFocus: onFocus,
            onBlur: onBlur,
            disabled: __props.disabled,
            value: __props.value,
            required: "",
            onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
          }, null, 42, _hoisted_2),
          _createElementVNode("span", {
            class: _normalizeClass(["webins-floating-label", { 'webins-error-field': __props.errore }])
          }, _toDisplayString(__props.placeHolder), 3)
        ], 64))
      : (__props.type === 'select')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("select", {
              ref_key: "field",
              ref: field,
              class: _normalizeClass(["webins-custom-input", { 'focus': hasFocus.value || __props.value, 'webins-error-field': __props.errore  }]),
              onChange: handleSelectChange,
              value: __props.value,
              disabled: __props.disabled,
              onFocus: onFocus,
              onBlur: onBlur
            }, [
              (__props.optionLabel)
                ? (_openBlock(), _createElementBlock("option", _hoisted_4, _toDisplayString(__props.optionLabel), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSource, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item[ __props.valueField ? __props.valueField : 'value' ],
                  value: item[ __props.valueField ? __props.valueField : 'value' ]
                }, _toDisplayString(item.text), 9, _hoisted_5))
              }), 128))
            ], 42, _hoisted_3),
            _hoisted_6,
            _createElementVNode("span", {
              class: _normalizeClass(["webins-floating-label webins-fixed-label", { 'webins-error-field': __props.errore  }])
            }, [
              _createTextVNode(_toDisplayString(__props.placeHolder) + " ", 1),
              (__props.hint)
                ? (_openBlock(), _createBlock(IconInfo, {
                    key: 0,
                    class: "webins-input-info",
                    title: __props.hint,
                    testoPopup: __props.hint
                  }, null, 8, ["title", "testoPopup"]))
                : _createCommentVNode("", true)
            ], 2)
          ], 64))
        : (__props.type === 'date')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_unref(VueDatePicker), {
                ref_key: "datepicker",
                ref: datepicker,
                modelValue: _unref(dateModel),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dateModel) ? (dateModel).value = $event : null)),
                placeholder: "GG/MM/AAAA",
                disabled: __props.disabled,
                "auto-position": true,
                "text-input": { format: 'dd/MM/yyyy' },
                format: formatDate,
                locale: "it",
                cancelText: "Annulla",
                selectText: "Seleziona",
                "enable-time-picker": false,
                onDateUpdate: dateClicked,
                "model-type": "dd/MM/yyyy",
                "calendar-class-name": "dp-webins-calendar",
                "menu-class-name": "dp-custom-menu",
                onBlur: onCloseDate,
                "min-date": __props.minDate,
                "max-date": __props.maxDate
              }, {
                "dp-input": _withCtx(({ value, onInput,  onKeypress, onEnter }) => [
                  _createElementVNode("input", {
                    ref_key: "inputDate",
                    ref: inputDate,
                    class: _normalizeClass(["dp__input", { 'webins-error-field': __props.errore }]),
                    type: "text",
                    value: value,
                    onInput: onInput,
                    onKeypress: ($event: any) => (onDatePickerKeyPress($event, onKeypress, onEnter)),
                    placeholder: "GG/MM/AAAA"
                  }, null, 42, _hoisted_7),
                  _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg",
                    "svg-inline": '',
                    class: _normalizeClass('webins-calendar-icon'),
                    onClick: openDatePicker,
                    role: 'presentation',
                    focusable: 'false',
                    tabindex: '-1'
                  }, _hoisted_9)
                ]),
                "action-row": _withCtx(() => []),
                _: 1
              }, 8, ["modelValue", "disabled", "min-date", "max-date"]),
              _createElementVNode("span", {
                class: _normalizeClass(["webins-floating-label webins-fixed-label", { 'webins-error-field': __props.errore }])
              }, _toDisplayString(__props.placeHolder), 3)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("input", {
                class: _normalizeClass([{ 'focus': hasFocus.value || __props.value, 'webins-error-field': __props.errore  }, "webins-custom-input"]),
                ref_key: "field",
                ref: field,
                onInput: handleInput,
                onChange: handleInput,
                type: __props.email ? 'email' : 'text',
                onFocus: onFocus,
                onBlur: onBlur,
                disabled: __props.disabled,
                value: __props.value,
                required: ""
              }, null, 42, _hoisted_10),
              _createElementVNode("span", {
                class: _normalizeClass(["webins-floating-label", { 'webins-error-field': __props.errore  }])
              }, _toDisplayString(__props.placeHolder), 3)
            ], 64))
  ]))
}
}

})